import { commonChecks, getOSVersion } from '@xhs/ozone-detector'

export default function completeUrl(url) {
  if (!process.env.BROWSER) {
    return url
  }

  if (!url.startsWith('http')) {
    if (!url.startsWith('//')) {
      return window.location.origin + url
    }

    return window.location.protocol + url
  }

  return url
}

export function webp2png(res) {
  if (commonChecks.isIOS) {
    let image = res?.response?.image || res?.response?.images
    // ios 14 以下的系统在 webview 不支持 webp 格式的图片，替换为 png 格式。
    const OSVersion = getOSVersion()
    if (OSVersion?.major < 14 && image?.endsWith('format/webp')) {
      image = `${image.substring(0, image.length - 4)}png`
      res.response.image = image
      res.response.images = image
    }
  }
}
